import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/BookingSuccessModal.css";

const UploadSuccessModal = ({ isOpen, onClose, fetchBookings, editMode }) => {
  const navigate = useNavigate();
  const [reloadKey, setReloadKey] = useState(0);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="success-icon">
          <div className="check-circle">
            <i className="fas fa-check"></i>
          </div>
        </div>
        <h2 className="thank-you-heading">Thank you!</h2>
        <p className="success-message">
          The document has been uploaded successfully!
        </p>

        {/* OK button to reload bookings */}
        <button
          className="go-home-button"
          onClick={() => {
            if (fetchBookings) fetchBookings();
            if (onClose) onClose();
          }}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default UploadSuccessModal;
